import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { LoginPage } from '../features/auth/LoginPage';

const search = z.object({
  error: z.enum(['not_invited', 'wrong_tenant', 'disabled', 'failed']).optional().catch(undefined),
  dev: z.coerce.number().optional().catch(undefined),
  returnTo: z.string().startsWith('/').optional().catch(undefined),
});

export const Route = createFileRoute('/login')({
  validateSearch: search,
  component: LoginPage,
});
